import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import { SettingsProvider } from "@/context/SettingsContext";
import PublicLayout from "@/layouts/PublicLayout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Wishlist from "@/pages/Wishlist";
import About from "@/pages/About";
import Gifts from "@/pages/Gifts";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductEdit from "@/pages/admin/AdminProductEdit";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminAffiliates from "@/pages/admin/AdminAffiliates";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminLoyalty from "@/pages/admin/AdminLoyalty";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminSliders from "@/pages/admin/AdminSliders";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminPages from "@/pages/admin/AdminPages";
import AdminFooterPages from "@/pages/admin/AdminFooterPages";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import DynamicPage from "@/pages/DynamicPage";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import Portrait from "@/pages/Portrait";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <SettingsProvider>
          <StoreProvider>
            <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/kartini" element={<Catalog />} />
                <Route path="/kartina/:slug" element={<ProductDetail />} />
                <Route path="/kolichka" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/lyubimi" element={<Wishlist />} />
                <Route path="/za-avtora" element={<About />} />
                <Route path="/podaratsi" element={<Gifts />} />
                <Route path="/kontakti" element={<Contact />} />
                <Route path="/portreti" element={<Portrait />} />
                <Route path="/stranitsa/:slug" element={<DynamicPage />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="products/new" element={<AdminProductEdit />} />
                <Route path="products/:id" element={<AdminProductEdit />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="inquiries" element={<AdminInquiries />} />
                <Route path="reviews" element={<AdminReviews />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="payments" element={<AdminPayments />} />
                <Route path="loyalty" element={<AdminLoyalty />} />
                <Route path="affiliates" element={<AdminAffiliates />} />
                <Route path="referrals" element={<AdminReferrals />} />
                <Route path="coupons" element={<AdminCoupons />} />
                <Route path="pages" element={<AdminPages />} />
                <Route path="footer-pages" element={<AdminFooterPages />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="sliders" element={<AdminSliders />} />
                <Route path="media" element={<AdminMedia />} />
                <Route path="analytics" element={<AdminAnalytics />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          </StoreProvider>
        </SettingsProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
